// composables/useNotification.ts
export function useNotification() {
	// 알림 권한 요청 여부
	const isNotificationGranted = computed(() => Notification.permission === 'granted');
	// 알림 시간 기록
	let lastNotificationTime = 0;
	// 💡 알림 제목 중복 방지
	const shownTitles = new Set<string>();

	const requestPermission = async () => {
		if (!('Notification' in window)) return false;
		const permission = await Notification.requestPermission();
		return permission === 'granted';
	};

	const notify = (title: string, body: string, icon = '/img/logo.svg') => {
		console.log('Notification:', title, body);
		const now = Date.now();

		// 💡 1. 동일 제목 반복 방지 (10초 이내)
		if (shownTitles.has(title) && now - lastNotificationTime < 10000) return;

		if (isNotificationGranted) {
			const notification = new Notification(title, {
				body,
				icon,
			});

			notification.onclick = () => {
				window.open(window.location.origin, '_blank');
			};

			// 기록 저장
			shownTitles.add(title);
			lastNotificationTime = now;

			// 1분 뒤 title 기록 제거
			setTimeout(() => shownTitles.delete(title), 60000);
		}
	};

	return { requestPermission, notify, isNotificationGranted };
}